import { bool, func, oneOfType, shape, string } from 'prop-types'
import { connectToggleRefinement } from 'react-instantsearch-dom'

import store from 'shared/store'
import { PRODUCT_FILTER_CHANGED } from 'shared/store/ducks/events'
import { upperCaseFirst } from 'shared/utils/stringUtils'
import InputCheckbox from 'views/components/molecules/InputCheckbox'
import { SHIPPING_OPTIONS_FILTER_NAME } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter/consts'

const RefinementItem = ({
  id,
  refine,
  currentRefinement,
  label,
  count,
  nowLabel,
  customRefinementGroupName,
}) => {
  const onChangeHandler = () => {
    refine(!currentRefinement)
    store.dispatch({
      type: PRODUCT_FILTER_CHANGED,
      selected: label,
      attribute: customRefinementGroupName,
      value: !currentRefinement,
      refine,
      shippingOptions:
        customRefinementGroupName === SHIPPING_OPTIONS_FILTER_NAME,
    })
  }

  return count?.unchecked ? (
    <li className="u-no-border-radius u-border--bottom@small-tiny u-padding@small-tiny u-margin-x-small--bottom@medium o-AlgoliaInstantSearch__RefinementItem">
      <InputCheckbox
        id={`${id}-checkbox`}
        name={`${id}-checkbox`}
        checked={currentRefinement}
        onChange={onChangeHandler}
        disableAutoCompleteAndFriends
        nowLabel={nowLabel}
        labelSize="small"
      >
        {upperCaseFirst(label)} ({count.unchecked})
      </InputCheckbox>
    </li>
  ) : null
}

RefinementItem.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  refine: func.isRequired,
  currentRefinement: oneOfType([bool, string]).isRequired,
  count: shape({}).isRequired,
  customRefinementGroupName: string.isRequired,
  nowLabel: bool,
}
RefinementItem.defaultProps = {
  nowLabel: false,
}
export default connectToggleRefinement(RefinementItem)
